import React from 'react';

import ServiceItemContainer from 'onboarding/stylists/ServiceItem';

class CategoryItem extends React.Component {
  static defaultProps = {
    stylist: null,
  };

  constructor(props) {
    super(props);
    let checked = false;

    if (window.document.location.href.indexOf('signup') > 0) {
      if (props.category && props.categoryExecutions) {
        for (let i = 0; i < props.categoryExecutions.length; i += 1) {
          if (props.categoryExecutions[i].category === props.category.id) {
            checked = true;
          }
        }
      }
    } else if (props.stylist && props.stylist.services) {
      checked = props.stylist.services.filter((s) => s.category.id === props.category.id).length > 0;
    }
    this.state = {
      checked,
    };
  }

  onCheckboxChange = () => {
    this.setState({ checked: !this.state.checked });
    if (this.props.category.id) {
      this.props.onCategoryCheckboxChange(this.props.category.id);
    }
  };

  render() {
    let activeColor = '#080b0f'; // black
    let disabled = '';
    if (window.document.location.href.indexOf('signup') < 0) {
      disabled = 'disabled';
    }
    if (!this.state.checked) {
      activeColor = '#b3b3b3'; // gray
    } else {
      activeColor = '#080b0f';
    }
    return (
      <div className="rounded-border-wrap">
        <div className="rank-list-item cItems">
          <div className="checkbox-switch-wrap">
            <input
              type="checkbox"
              className="checkbox-switch"
              id={`${this.props.category.name}${this.props.category.id ? this.props.category.id : 'category'}`}
              onChange={this.onCheckboxChange}
              checked={this.state.checked}
              disabled={disabled}
            />
            <label style={{ color: activeColor }} htmlFor={`${this.props.category.name}${this.props.category.id ? this.props.category.id : 'category'}`} className="checkbox-bullet">
              {this.props.category.name}
              <div style={{ backgroundColor: this.props.category.color }} />
            </label>
          </div>
        </div>
        {this.props.category.services && this.props.category.services.length > 0 && this.state.checked && (
          <div className="items-div cItems">
            {this.props.category.services.map((service) => (
              <ServiceItemContainer onCheckboxChange={this.props.onServiceCheckboxChange} service={service} key={service.id} roleId={this.props.roleId} stylist={this.props.stylist} />
            ))}
          </div>
        )}
      </div>
    );
  }
}

export default CategoryItem;
